module.exports = __webpack_public_path__ + "img/bg_image_4.b5397fb8.png";